import styled from "styled-components";

const Button = styled.button`
    font-family: "Inter", sans-serif !important;
    display: block;
    width: 100%;
    background: #FE8418;
    text-transform: uppercase;
    color: #fff;
    font-weight: bold !important;
    border-radius: 24px;
    padding: 8px;
    box-shadow: 0px 2px 0px #E16F09;

    &:hover {
        background: #E16F09;
        box-shadow: 0px 2px 0px #FE8418;
    }

    &:disabled:hover {
        cursor: no-drop;
        background: #FE8418;
        box-shadow: 0px 2px 0px #E16F09;
    }
`;

type ScheduleButtonProps = {
    disabled: boolean;
    children: any;
};

const ScheduleButton: React.FC<ScheduleButtonProps> = ({ disabled, children }) => {
    return (
        <Button className="schedule-button" type="submit" disabled={disabled}>
            {children}
        </Button>
    );
};

export default ScheduleButton;
